import { useSearch } from '../../hooks/context';

const useDiscount = () => {
  const { shops = {} } = useSearch();

  return shops.data || {};
};

export default useDiscount;
